// @flow

import "./UserRow.css";

import { connect } from 'react-redux'
import { fetchGames, fetchPosts, fetchGamesActon } from './actions'
import type {User} from './types'

import type {Node} from 'react';
import React from 'react';

const COLORS = ["#ff8112", "#aeaeae", "#535353", "#004fce", "#74a3f3"];

type TProps = {
    idx: number, 
    user: User, 
    is_their_turn: boolean
}

function UserRow({ 
    idx, 
    user, 
    is_their_turn}: TProps): Node {
    const mystyle = {
        //"background-color": "#f00",
        "background": "radial-gradient(silver, black)",
        "border": "2px solid black",
        "height": "75px",
        "border-radius": "50%",
        "-moz-border-radius": "50%",
        "-webkit-border-radius": "50%",
        "width": "75px",
        "margin-left": "5px",
        "margin-right": "5px",
    };


    const mystyle2 = {
        "background-color": COLORS[idx],
        //"background": "radial-gradient(silver, black)",
        //"border": "1px solid black",
        "height": "65px",
        "border-radius": "50%",
        "-moz-border-radius": "50%",
        "-webkit-border-radius": "50%",
        "width": "65px",
        "margin-left": "5px",
        "margin-right": "5px",
        "margin-top": "5px",
        "display": "flex",
        "align-items": "center",
        "justify-content": "center"
    };


    return <div className={is_their_turn ? "AnimateVertical" : ""} style={{ paddingLeft: "10px", paddingRight: "10px", display: "flex", alignItems: "center", flexDirection: "column" }}>
        <div style={mystyle} >
            <div style={mystyle2}>
                <div style={{
                    fontSize: "40px",
                    fontFamily: "'EB Garamond', serif",
                }}>{user.name[0].toUpperCase()}
                </div>
            </div>
        </div>
        <div style={{
            fontSize: "calc(15px + 0.5vmin)",
            fontFamily: "'EB Garamond', serif",
        }}>
            {user.name}
        </div>
    </div>;
}
export default UserRow;

